"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_fsa_1 = __importDefault(require("typescript-fsa"));

var actionCreator = typescript_fsa_1.default();
/*=====================================
    PAYLOAD TYPES
======================================*/

/*=====================================
    ACTIONS
======================================*/

exports.default = {
  /* Images
  =====================================*/
  setImages: actionCreator('SET_IMAGES')
};